<script setup>
import FeaturedBanner from '@/components/featured-post-banner/FeaturedBanner.vue';

const props = defineProps({
    data: { type: Object, default: () => {} },
    mainColor: {
        type: String,
        default: '',
    },
    color: {
        type: String,
        default: '',
    },
});

console.log(props);
</script>

<template>
    <div class="FeaturedPostBanner">
        <FeaturedBanner
            :title="data.data.featuredContentTitle"
            :cta-main="data.data.featuredContentMainLinkText"
            :cta-main-sub="data.data.featuredContentLinkText"
            :cta-small="false"
            :cta="false"
            :color="color"
            :cta-link="data.data.featuredContentMainLink"
            :cta-main-link="data.data.featuredContentLink"
            :image="data.data.flexibleImage"
            :btn-icon="false"
            :cta-main-link-new-tab="data.data.featuredContentMainLinkNewTab"
            :cta-link-new-tab="data.data.featuredContentLinkNewTab"
            :main-color="mainColor"
        >
            <template #text>
                <div
                    class="FeaturedPostBannerText"
                    v-html="data.data.featuredContentText"
                />
            </template>
        </FeaturedBanner>
    </div>
</template>
